import { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import AbstractStayStrategyModel from 'uplisting-frontend/models/abstract-stay-strategy';

export type LeadDays = 7 | 14 | 28;

export const LEAD_DAYS: LeadDays[] = [7, 14, 28];

export default class LeadTimeRateRuleModel extends AbstractStayStrategyModel {
  @attr('boolean') enabled!: boolean;
  @attr('number') leadDays!: LeadDays;

  @belongsTo('property', {
    inverse: null,
    async: false,
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'lead-time-rate-rule': LeadTimeRateRuleModel;
  }
}
